<a [routerLink]="['/sync-devices']" routerLinkActive="router-link-active">
    <div class="sync-devices-button">
        <img width="30px" height="30px" src="../../assets/icons/sync-devices.svg">
    </div>
</a>